module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.3dcc0e0f2287e2e955cd.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Bold-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.ttf
// module chunks = styles